import React from 'react';
import {
  People,
  Business,
  Group,
  Dashboard as DashboardIcon,
  Notifications,
  AccountTree,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  AdminPanelSettings as AdminIcon,
} from '@mui/icons-material';
import {
  EntityType,
  PermissionLevel,
} from '../../../../../generated/data-contracts';

// Configuración visual mejorada para entidades
export const entityConfig = {
  [EntityType.CLIENT]: {
    icon: <People sx={{ fontSize: 24 }} />,
    name: 'Clientes',
    description: 'Gestión de información de clientes',
    color: '#2196F3',
    bgColor: '#E3F2FD',
  },
  [EntityType.PLANT]: {
    icon: <Business sx={{ fontSize: 24 }} />,
    name: 'Plantas',
    description: 'Gestión de plantas industriales',
    color: '#9C27B0',
    bgColor: '#F3E5F5',
  },
  [EntityType.DASHBOARDGROUP]: {
    icon: <Group sx={{ fontSize: 24 }} />,
    name: 'Grupos de Dashboard',
    description: 'Agrupaciones de dashboards',
    color: '#00BCD4',
    bgColor: '#E0F7FA',
  },
  [EntityType.DASHBOARD]: {
    icon: <DashboardIcon sx={{ fontSize: 24 }} />,
    name: 'Dashboards',
    description: 'Tableros de control y visualización',
    color: '#4CAF50',
    bgColor: '#E8F5E8',
  },
  [EntityType.ALERT]: {
    icon: <Notifications sx={{ fontSize: 24 }} />,
    name: 'Alertas',
    description: 'Sistema de notificaciones',
    color: '#FF9800',
    bgColor: '#FFF3E0',
  },
  [EntityType.DIAGRAM]: {
    icon: <AccountTree sx={{ fontSize: 24 }} />,
    name: 'Diagramas',
    description: 'Diagramas y esquemas',
    color: '#F44336',
    bgColor: '#FFEBEE',
  },
};

// Configuración visual para niveles de permiso
export const permissionConfig = {
  [PermissionLevel.READ]: {
    icon: <VisibilityIcon sx={{ fontSize: 16 }} />,
    label: 'Lectura',
    color: '#2196F3',
    description: 'Solo visualización',
  },
  [PermissionLevel.WRITE]: {
    icon: <EditIcon sx={{ fontSize: 16 }} />,
    label: 'Escritura',
    color: '#FF9800',
    description: 'Crear y modificar',
  },
  [PermissionLevel.ADMIN]: {
    icon: <AdminIcon sx={{ fontSize: 16 }} />,
    label: 'Administrador',
    color: '#F44336',
    description: 'Control total',
  },
};
